import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _dec2, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field, change } from 'redux-form';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { LLTextField, LLDropDownList, LLDatePicker, LLSelectField } from 'components/FormElements';
import MenuItem from 'material-ui/MenuItem';
import { GrayButton, SecondaryButton } from 'components';
var NewClientForm = (_dec = connect(function (state) {
  return {
    products: state.teamManagement.products,
    initialValues: {
      productId: state.teamManagement.products.length ? state.teamManagement.products[0].id : null
    },
    formValues: state.form.newClient ? state.form.newClient.values : {}
  };
}, {
  change: change
}), _dec2 = reduxForm({
  form: 'newClient'
}), _dec(_class = _dec2(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(NewClientForm, _Component);

  var _super = _createSuper(NewClientForm);

  function NewClientForm(props) {
    var _this;

    _classCallCheck(this, NewClientForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "initialValues", {});

    _defineProperty(_assertThisInitialized(_this), "renderDropdownList", function (_ref) {
      var input = _ref.input,
          rest = _objectWithoutProperties(_ref, ["input"]);

      return /*#__PURE__*/React.createElement(LLDropDownList, _extends({
        items: rest.data
      }, input, rest));
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref2) {
      var children = _ref2.children,
          input = _ref2.input,
          label = _ref2.label,
          type = _ref2.type,
          className = _ref2.className,
          inputStyles = _ref2.styles,
          style = _ref2.style,
          _ref2$meta = _ref2.meta,
          touched = _ref2$meta.touched,
          error = _ref2$meta.error;
      var component = null;

      switch (type) {
        case 'date':
          component = /*#__PURE__*/React.createElement("div", {
            className: "row"
          }, /*#__PURE__*/React.createElement(LLDatePicker, _extends({
            style: style
          }, input, {
            placeholder: label,
            id: input.name
          })));
          break;

        case 'select':
          component = /*#__PURE__*/React.createElement(LLSelectField, _extends({}, input, {
            style: {
              top: 10
            },
            label: label
          }), children);
          break;

        default:
          component = /*#__PURE__*/React.createElement(LLTextField, _extends({}, input, {
            placeholder: label,
            type: type,
            className: className,
            id: input.name,
            style: {
              width: '100%'
            }
          }));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "form-group ".concat(error && touched ? 'has-error' : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-sm-12 ".concat(inputStyles.inputGroup)
      }, component, error && touched && /*#__PURE__*/React.createElement("div", {
        className: "text-danger"
      }, error)));
    });

    _this.state = {
      selectedTab: 0
    };
    return _this;
  }

  _createClass(NewClientForm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          styles = _this$props.styles,
          handleSubmit = _this$props.handleSubmit;
      return /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          padding: '0 32px',
          maxWidth: 900
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-sm-6"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "firstName",
        type: "text",
        component: this.renderInput,
        label: "First Name",
        className: "form-control",
        styles: styles
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-sm-6"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "lastName",
        type: "text",
        component: this.renderInput,
        label: "Last Name",
        className: "form-control",
        styles: styles
      }))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-sm-12"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "email",
        type: "email",
        component: this.renderInput,
        label: "Email",
        className: "form-control",
        styles: styles
      }))), /*#__PURE__*/React.createElement(Field, {
        name: "businessName",
        type: "text",
        component: this.renderInput,
        label: "Business Name",
        className: "form-control",
        styles: styles
      }), /*#__PURE__*/React.createElement(Field, {
        name: "address1",
        type: "text",
        component: this.renderInput,
        label: "Address Line 1",
        className: "form-control",
        styles: styles
      }), /*#__PURE__*/React.createElement(Field, {
        name: "address2",
        type: "text",
        component: this.renderInput,
        label: "Address Line 2",
        className: "form-control",
        styles: styles
      }), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-sm-5"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "locality",
        type: "text",
        component: this.renderInput,
        label: "City",
        className: "form-control",
        styles: styles
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-sm-4"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "region",
        type: "text",
        component: this.renderInput,
        label: "State/Province",
        className: "form-control",
        styles: styles
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-sm-3"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "postcode",
        type: "text",
        component: this.renderInput,
        label: "Zip Code",
        className: "form-control",
        styles: styles
      }))), /*#__PURE__*/React.createElement(Field, {
        name: "phone",
        type: "text",
        component: this.renderInput,
        label: "Phone Number",
        className: "form-control",
        styles: styles
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 16
        }
      }, /*#__PURE__*/React.createElement(GrayButton, {
        onClick: function onClick() {
          return browserHistory.push('/global/clients');
        },
        label: "Cancel",
        style: {
          marginRight: 12
        }
      }), /*#__PURE__*/React.createElement(SecondaryButton, {
        label: "Save"
      }))));
    }
  }]);

  return NewClientForm;
}(Component), _defineProperty(_class2, "propTypes", {
  styles: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  products: PropTypes.array.isRequired
}), _temp)) || _class) || _class);
export { NewClientForm as default };